import { Route, Switch } from 'react-router';

import ExpertRouter from '@components/expert/ExpertRouter';
import ExpertJourneyRouter from '@components/expertJourney/ExpertJourneyRouter';
import UniversalSearch from '@components/UniversalSearch';

// The need for this kinda stinks... we need to render the universal search at this level or else we
// get issues with the queries using the wrong access tokens when impersonating experts (I have no idea why).
// But we only want to render it for experts, and if we render it in each of the expert routers then
// there will be two versions of it with separate state. So this component exists only to render that and
// also the appropriate expert router.
const ExpertWrapperRouter = () => (
  <>
    <Switch>
      <Route
        path="/expert/journeys/:journeyId"
        render={params => <ExpertJourneyRouter journeyId={params.match.params.journeyId} />}
      />
      <Route path="/expert" render={() => <ExpertRouter />} />
    </Switch>
    <UniversalSearch />
  </>
);

export default ExpertWrapperRouter;
